export enum HelpCenterLinkLocation {
  ACCOUNT_MENU = 'Account menu',
  MENU = 'Menu',
  MENU_MOBILE = 'Menu mobile',
  FOOTER = 'Footer',
}
